import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '@/store';
import MainHeader from './MainHeader';
import MessageList from './MessageList';
import MessageInput from './MessageInput';
import Sidebar from '@/chats/Sidebar';
import { openSidebar, closeSidebar } from '@/chats/chatSlice';

export default function MainPage() {
  const dispatch = useAppDispatch();
  const sidebarOpen = useAppSelector((s) => s.chats.sidebarOpen);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      const target = e.target as HTMLElement;
      if (target.tagName === "INPUT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
      if (e.key === "ArrowLeft") dispatch(closeSidebar());
      if (e.key === "ArrowRight") dispatch(openSidebar());
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [dispatch]);

  useEffect(() => {
    const update = () => {
      const vv = window.visualViewport;
      const h = vv?.height ?? window.innerHeight;
      document.documentElement.style.setProperty("--app-height", `${h}px`);
    };
    update();
    window.visualViewport?.addEventListener("resize", update);
    window.visualViewport?.addEventListener("scroll", update);
    return () => {
      window.visualViewport?.removeEventListener("resize", update);
      window.visualViewport?.removeEventListener("scroll", update);
    };
  }, []);

  return (
    <div className="relative h-[var(--app-height)] w-screen overflow-hidden bg-slate-100">
      <Sidebar />
      <div
        className={`absolute inset-0 flex flex-col transition-all duration-300
          ${sidebarOpen ? "md:ml-[320px]" : "md:ml-0"}
        `}
      >
        <MainHeader />
        <div className="flex-1 flex justify-center overflow-hidden">
          <div className="w-full max-w-screen-sm flex flex-col overflow-hidden">
            <MessageList />
            <MessageInput />
          </div>
        </div>
      </div>
    </div>
  );
}
